import React from "react";
import ContactCTA from "@/components/professions/ContactCTA";

const GaragisteContact = () => {
  return (
    <section id="contact-section" className="py-20 bg-gradient-to-br from-fabre-green to-fabre-darkgreen text-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-heading font-bold mb-6">
            Simplifiez la gestion de vos déchets automobiles
          </h2>
          <div className="w-24 h-1 bg-white/30 mx-auto mb-8 rounded-full"></div>
          <p className="text-xl opacity-90 mb-12 leading-relaxed">
            Contactez nos experts pour une étude personnalisée de votre garage. 
            Devis gratuit et intervention rapide garantie.
          </p>
          
          <ContactCTA />
        </div>
      </div>
    </section>
  );
};

export default GaragisteContact;